import PropTypes from 'prop-types';

import { Button, Card, Col, Form, Image, Row } from 'react-bootstrap';

import classNames from 'classnames';

import { useDonationContextProvider } from 'context/DonationContextProvider';

import img from 'assets/img/we-raise-images/front-end/gift-aid-logo_png-1.png';
import { formatMoney } from 'helpers/utils';

function GiftAidCard(props) {
  const { logoPosition } = props;

  const { giftAid, setGiftAid, totalAmount } = useDonationContextProvider();
  const amountWithGiftAid = totalAmount * 1.25;

  return (
    <Card className="wr-donation-shadow p-4 wr-donation-text-grey-1000">
      <Card.Header className="p-0 mb-3 d-flex justify-content-between align-items-center">
        <span className="text-uppercase wr-donation-header3">gift aid your donation</span>
        <Button
          size="sm"
          variant="primary"
          href="https://www.youtube.com/watch?v=J082ei8ndbw"
          target="_blank"
          rel="noopener noreferrer"
        >
          What's Gift Aid?
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        <Row className="g-3">
          <Col
            md={logoPosition === 'right' ? 8 : 12}
            className={classNames('order-1', {
              'order-md-0': logoPosition === 'right'
            })}
          >
            <p className="wr-donation-subtitle1 mb-0">
              Add 25% more to your donation at no cost to you.
            </p>
            <p className="wr-donation-body1 mb-3">
              A Gift Aid declaration allows us to claim tax back on your gift
            </p>
            <p className="wr-donation-subtitle1 mb-3">
              With Gift Aid, your donation of{' '}
              <span className="text-primary fw-bold">
                {formatMoney(totalAmount, '£')}
              </span>{' '}
              will be
              <span className="text-primary fw-bold">
                {' '}
                {formatMoney(amountWithGiftAid, '£')}
              </span>{' '}
              with no extra to you
            </p>
            <Form.Check
              type="checkbox"
              className="m-0 d-flex align-items-center gap-2 custom-checkbox-lg"
            >
              <Form.Check.Input
                id="wr-donation-gift-aid-checkbox"
                isValid
                className="mt-0"
                checked={giftAid}
                onChange={e => setGiftAid(e.target.checked)}
              />
              <label
                htmlFor="wr-donation-gift-aid-checkbox"
                className="wr-donation-body4 mb-0"
              >
                I am a UK taxpayer, <br />
                Reclaim gift aid on my donation
              </label>
            </Form.Check>
          </Col>
          <Col
            md={4}
            className={classNames('align-self-center order-0', {
              'order-md-1': logoPosition === 'right'
            })}
          >
            <Image src={img} fluid style={{ maxWidth: '150px' }} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export { GiftAidCard };

GiftAidCard.propTypes = {
  logoPosition: PropTypes.oneOf(['below_header', 'right'])
};
